import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { CompanyDeletionRequestHttpClient } from './deletion-request-http.service';
import { CompanyDeletionRequestActions, actions } from './deletion-request.store';

@Injectable({ providedIn: 'root' })
export class CompanyDeletionRequestEffects {
  private effect = createEffectFactory(actions, this.actions$);

  private fetch$ = this.effect(CompanyDeletionRequestActions.fetch, () =>
    this.companyDeletionRequestHttpClient.fetch(),
  );

  private createDeletionRequest$ = this.effect(
    CompanyDeletionRequestActions.createDeletionRequest,
    ({ payload }) =>
      this.companyDeletionRequestHttpClient.createDeletionRequest(payload.secureChangeToken).pipe(
        switchMap(() => of(CompanyDeletionRequestActions.createDeletionRequestSuccess())),
        catchError(err =>
          of(CompanyDeletionRequestActions.createDeletionRequestFailed({ payload: err })),
        ),
      ),
  );

  constructor(
    private actions$: Actions,
    private companyDeletionRequestHttpClient: CompanyDeletionRequestHttpClient,
  ) {}
}
